import React, { useState } from "react";
import im1 from '../assets/various/im1.jpg';
import im2 from '../assets/various/im2.jpg';
import im3 from '../assets/portifolio/FIdel.jpg';
import im4 from '../assets/portifolio/Ethiopian_Tour.jpg';
import im5 from '../assets/portifolio/Awtar_Music_app.jpg';
import im6 from '../assets/portifolio/Art_Photo_Exhibition.jpg';
import im7 from '../assets/portifolio/Addis_Shopping_Festival.jpg';
import im8 from '../assets/portifolio/Wedesera.jpg';
import im12 from '../assets/portifolio/BetKing_Ethiopia.jpg';
import im13 from '../assets/portifolio/Mirkuzhomecare.jpg';
import im14 from '../assets/portifolio/Talary_jewelry.jpg';
import im15 from '../assets/portifolio/Maryland_liquor_Store.jpg';
import im16 from '../assets/portifolio/The_legend_coffee.jpg';
import im17 from '../assets/portifolio/Alliance_ethio_francis.jpg';
import im18 from '../assets/portifolio/Zemach_FM.jpg';
import im19 from '../assets/portifolio/Lois_Kids_Clothing.jpg';
import im20 from '../assets/portifolio/Sina_Leather.jpg';
import im21 from '../assets/portifolio/DDI_Ethiopia.jpg';

const Porti = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  
  // All images in order they appear in your layout
  const allImages = [
    { src: im12, alt: "Ato Creative portifolio 16" },
    { src: im13, alt: "Ato Creative portifolio 15" },
    { src: im14, alt: "Ato creative 1" },
    { src: im15, alt: "Ato creative digital marketing 2" },
    { src: im16, alt: "Ato creative digital marketing 3" },
    { src: im17, alt: "Ato creative digital marketing 4" },
    { src: im18, alt: "Ato creative digital marketing 5" },
    { src: im19, alt: "Ato creative digital marketing 6" },
    { src: im20, alt: "Ato creative digital marketing 7" },
    { src: im21, alt: "Ato creative digital marketing 8" },
    { src: im3, alt: "Ato creative digital marketing 9" },
    { src: im8, alt: "Ato creative digital marketing 10" },
    { src: im7, alt: "Ato creative digital marketing 11" },
    { src: im4, alt: "Ato creative digital marketing 12" },
    { src: im5, alt: "Ato creative digital marketing 13" },
    { src: im6, alt: "Ato creative digital marketing 14" }
  ];

  const openLightbox = (index) => {
    setSelectedImage(allImages[index]);
    setCurrentIndex(index);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  const navigate = (direction) => {
    let newIndex = currentIndex + direction;
    if (newIndex < 0) newIndex = allImages.length - 1;
    if (newIndex >= allImages.length) newIndex = 0;
    
    setCurrentIndex(newIndex);
    setSelectedImage(allImages[newIndex]);
  };

  return (
    <div className="relative min-h-auto w-full ">
      <div className="text-start mb-8">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 inline-block border-b-4 border-[#FD5F20]">
          <strong>Stories We Have Told</strong>
        </h1>
      </div>
      
      {/* Your existing layout with onClick handlers added */}
      <div className="grid gap-4 md:grid-cols-2 sm:grid-cols-1 lg:grid-cols-2">
        {/* First group */}
        <div className="grid gap-2 md:grid-cols-2 sm:grid-cols-1 lg:grid-cols-2 rounded  hover: transition-shadow duration-300 p-2">
          <div className="flex items-center grid gap-1 md:grid-cols-1 sm:grid-cols-1 lg:grid-cols-1">
            <div 
              className="relative w-full h-48 rounded-lg  transform transition-transform duration-300 group hover:scale-105 cursor-pointer"
              onClick={() => openLightbox(0)}
            >
              <img className="w-full h-full rounded-lg object-cover" src={im12} alt="Ato creative digital marketing  16" title="Ato creative digital marketing "  />
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-300 flex items-center justify-center">
                <span className="text-white text-lg font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  View More
                </span>
              </div>
            </div>
            <div 
              className="relative w-full h-48 rounded-lg  transform transition-transform duration-300 group hover:scale-105 cursor-pointer"
              onClick={() => openLightbox(1)}
            >
              <img className="w-full h-full rounded-lg object-cover" src={im13} alt="Ato creative digital marketing  15" title="Ato creative digital marketing "  />
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-300 flex items-center justify-center">
                <span className="text-white text-lg font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  View More
                </span>
              </div>
            </div>
          </div>
          <div className="flex items-center grid gap-1 md:grid-cols-1 sm:grid-cols-1 lg:grid-cols-1">
            <div 
              className="relative w-full h-64 rounded-lg  transform transition-transform duration-300 group hover:scale-105 cursor-pointer"
              onClick={() => openLightbox(2)}
            >
              <img className="w-full h-full rounded-lg object-cover" src={im14} alt="Ato creative digital marketing 1" title="Ato creative digital marketing "  />
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-300 flex items-center justify-center">
                <span className="text-white text-lg font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  View More
                </span>
              </div>
            </div>
            <div 
              className="relative w-full h-32 rounded-lg  transform transition-transform duration-300 group hover:scale-105 cursor-pointer"
              onClick={() => openLightbox(3)}
            >
              <img className="w-full h-full rounded-lg object-cover" src={im15} alt="Ato creative digital marketing 2" title="Ato creative digital marketing "  />
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-300 flex items-center justify-center">
                <span className="text-white text-lg font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  View More
                </span>
              </div>
            </div>
          </div>
        </div>
        
        {/* Second group */}
        <div className="grid gap-2 md:grid-cols-2 sm:grid-cols-1 lg:grid-cols-2 rounded ">
          <div className="flex items-center grid gap-1 md:grid-cols-1 sm:grid-cols-1 lg:grid-cols-1">
            <div 
              className="relative w-full h-48 rounded-lg  transform transition-transform duration-300 group hover:scale-105 cursor-pointer"
              onClick={() => openLightbox(4)}
            >
              <img className="w-full h-full rounded-lg object-cover" src={im16} alt="Ato creative digital marketing 3" title="Ato creative digital marketing "  />
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-300 flex items-center justify-center">
                <span className="text-white text-lg font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  View More
                </span>
              </div>
            </div>
            <div 
              className="relative w-full h-48 rounded-lg  transform transition-transform duration-300 group hover:scale-105 cursor-pointer"
              onClick={() => openLightbox(5)}
            >
              <img className="w-full h-full rounded-lg object-cover" src={im17} alt="Ato creative digital marketing 4" title="Ato creative digital marketing " />
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-300 flex items-center justify-center">
                <span className="text-white text-lg font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  View More
                </span>
              </div>
            </div>
          </div>
          <div className="flex items-center grid gap-1 md:grid-cols-1 sm:grid-cols-1 lg:grid-cols-1">
            <div 
              className="relative w-full h-32 rounded-lg  transform transition-transform duration-300 group hover:scale-105 cursor-pointer"
              onClick={() => openLightbox(6)}
            >
              <img className="w-full h-full rounded-lg object-cover" src={im18} alt="Ato creative digital marketing 5" title="Ato creative digital marketing " />
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-300 flex items-center justify-center">
                <span className="text-white text-lg font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  View More
                </span>
              </div>
            </div>
            <div 
              className="relative w-full h-64 rounded-lg  transform transition-transform duration-300 group hover:scale-105 cursor-pointer"
              onClick={() => openLightbox(7)}
            >
              <img className="w-full h-full rounded-lg object-cover" src={im19} alt="Ato creative digital marketing 6" title="Ato creative digital marketing "  />
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-300 flex items-center justify-center">
                <span className="text-white text-lg font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  View More
                </span>
              </div>
            </div>
          </div>
        </div>
        
        {/* Continue with the rest of your groups... */}
        {/* Third group */}
        <div className="grid gap-2 md:grid-cols-2 sm:grid-cols-1 lg:grid-cols-2 rounded ">
          <div className="flex items-center grid gap-1 md:grid-cols-1 sm:grid-cols-1 lg:grid-cols-1">
            <div 
              className="relative w-full h-64 rounded-lg  transform transition-transform duration-300 group hover:scale-105 cursor-pointer"
              onClick={() => openLightbox(8)}
            >
              <img className="w-full h-full rounded-lg object-cover" src={im20} alt="Ato creative digital marketing 7" title="Ato creative digital marketing"  />
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-300 flex items-center justify-center">
                <span className="text-white text-lg font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  View More
                </span>
              </div>
            </div>
            <div 
              className="relative w-full h-32 rounded-lg  transform transition-transform duration-300 group hover:scale-105 cursor-pointer"
              onClick={() => openLightbox(9)}
            >
              <img className="w-full h-full rounded-lg object-cover" src={im21} alt="Ato creative digital marketing 8"title="Ato creative digital marketing"  />
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-300 flex items-center justify-center">
                <span className="text-white text-lg font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  View More
                </span>
              </div>
            </div>
          </div>
          <div className="flex items-center grid gap-1 md:grid-cols-1 sm:grid-cols-1 lg:grid-cols-1">
            <div 
              className="relative w-full h-48 rounded-lg  transform transition-transform duration-300 group hover:scale-105 cursor-pointer"
              onClick={() => openLightbox(10)}
            >
              <img className="w-full h-full rounded-lg object-cover" src={im3} alt="Ato creative digital marketing 9" title="Ato creative digital marketing" />
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-300 flex items-center justify-center">
                <span className="text-white text-lg font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  View More
                </span>
              </div>
            </div>
            <div 
              className="relative w-full h-48 rounded-lg  transform transition-transform duration-300 group hover:scale-105 cursor-pointer"
              onClick={() => openLightbox(11)}
            >
              <img className="w-full h-full rounded-lg object-cover" src={im8} alt="Ato creative digital marketing 10" title="Ato creative digital marketing"  />
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-300 flex items-center justify-center">
                <span className="text-white text-lg font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  View More
                </span>
              </div>
            </div>
          </div>
        </div>
        
        {/* Fourth group */}
        <div className="grid gap-2 md:grid-cols-2 sm:grid-cols-1 lg:grid-cols-2 rounded ">
          <div className="flex items-center grid gap-1 md:grid-cols-1 sm:grid-cols-1 lg:grid-cols-1">
            <div 
              className="relative w-full h-32 rounded-lg  transform transition-transform duration-300 group hover:scale-105 cursor-pointer"
              onClick={() => openLightbox(12)}
            >
              <img className="w-full h-full rounded-lg object-cover" src={im7} alt="Ato creative digital marketing 11" title="Ato creative digital marketing"  />
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-300 flex items-center justify-center">
                <span className="text-white text-lg font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  View More
                </span>
              </div>
            </div>
            <div 
              className="relative w-full h-64 rounded-lg  transform transition-transform duration-300 group hover:scale-105 cursor-pointer"
              onClick={() => openLightbox(13)}
            >
              <img className="w-full h-full rounded-lg object-cover" src={im4} alt="Ato creative digital marketing 12" title="Ato creative digital marketing"  />
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-300 flex items-center justify-center">
                <span className="text-white text-lg font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  View More
                </span>
              </div>
            </div>
          </div>
          <div className="flex items-center grid gap-1 md:grid-cols-1 sm:grid-cols-1 lg:grid-cols-1">
            <div 
              className="relative w-full h-48 rounded-lg  transform transition-transform duration-300 group hover:scale-105 cursor-pointer"
              onClick={() => openLightbox(14)}
            >
              <img className="w-full h-full rounded-lg object-cover" src={im5} alt="Ato creative digital marketing 13" title="Ato creative digital marketing"  />
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-300 flex items-center justify-center">
                <span className="text-white text-lg font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  View More
                </span>
              </div>
            </div>
            <div 
              className="relative w-full h-48 rounded-lg  transform transition-transform duration-300 group hover:scale-105 cursor-pointer"
              onClick={() => openLightbox(15)}
            >
              <img className="w-full h-full rounded-lg object-cover" src={im6} alt="Ato creative digital marketing 14" title="Ato creative digital marketing"  />
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-300 flex items-center justify-center">
                <span className="text-white text-lg font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  View More
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          <div className="relative max-w-6xl w-full max-h-[90vh]">
            <button 
              className="absolute -top-12 right-0 text-white text-4xl z-50 hover:text-[#FD5F20] transition-colors"
              onClick={closeLightbox}
            >
              &times;
            </button>
            
            <div className="relative w-full h-full">
              <img 
                className="w-full h-full object-contain max-h-[80vh]" 
                src={selectedImage.src} 
                alt={selectedImage.alt} 
                onClick={(e) => e.stopPropagation()}
              />
              
              {/* Navigation arrows */}
              <button 
                className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-4 rounded-r-lg hover:bg-[#FD5F20] transition-colors"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(-1);
                }}
              >
                &#10094;
              </button>
              
              <button 
                className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-4 rounded-l-lg hover:bg-[#FD5F20] transition-colors"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(1);
                }}
              >
                &#10095;
              </button>
            </div>
            
            <p className="text-white text-center mt-4 text-xl">{selectedImage.alt}</p>
            <p className="text-white text-center mt-1">{currentIndex + 1} / {allImages.length}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Porti;